
import { getLocations } from "../../../../services/requests";
import { GetJDEStuckRecords, getLiquidBillingHeader, getLiquidBillingInvoices, getMonthlyStats, getPendingAutomaticInvoices, getPendingCreditInvoices, getPendingDeliveryInvoices, getPendingErrorInvoices, getPendingManualInvoices, UpdateLiquidBillingInvoice } from "../../../../services/requests/billing/liquid-billing-requests";
import { DataSource } from "../../../UI/view/data-source";

export const liquidMainDataSource = {
  request: getLiquidBillingInvoices,
  entityRequest: getLiquidBillingHeader,
  updateRequest: UpdateLiquidBillingInvoice,
  additionalRequests: [
    {
      name: 'liquidLocations',
      request: getLocations
    }
  ],
  pk: 'billingId',
  name: 'liquidbilling',
  serverSideEvents: true,
} as DataSource;

export const liquidBillingCreditDS = {
  request: getPendingCreditInvoices,
  entityRequest: getLiquidBillingHeader,
  updateRequest: UpdateLiquidBillingInvoice,
  pk: 'billingId',
  name: 'liquidbillingcredit',
} as DataSource;

export const liquidBillingDeliveryDS = {
  request: getPendingDeliveryInvoices,
  entityRequest: getLiquidBillingHeader,
  updateRequest: UpdateLiquidBillingInvoice,
  pk: 'billingId',
  name: 'liquidbillingdelivery',
} as DataSource;

export const liquidBillingManualDS = {
  request: getPendingManualInvoices,
  entityRequest: getLiquidBillingHeader,
  updateRequest: UpdateLiquidBillingInvoice,
  pk: 'billingId',
  name: 'liquidbillingmanual',
} as DataSource;

export const liquidBillingAutomaticDS = {
  request: getPendingAutomaticInvoices,
  entityRequest: getLiquidBillingHeader,
  updateRequest: UpdateLiquidBillingInvoice,
  pk: 'billingId',
  name: 'liquidbillingautomatic',
} as DataSource;

export const liquidBillingErrorDS = {
  request: getPendingErrorInvoices,
  entityRequest: getLiquidBillingHeader,
  updateRequest: UpdateLiquidBillingInvoice,
  pk: 'billingId',
  name: 'liquidbillingerror',
} as DataSource;

export const liquidMonthlyStatsDS = {
  request: getMonthlyStats,
  entityRequest: getLiquidBillingHeader,
  updateRequest: UpdateLiquidBillingInvoice,
  pk: 'billingId',
  name: 'liquidbillingmonthly',
} as DataSource;

export const jdeStuckRecordsDS = {
  request: GetJDEStuckRecords,
  entityRequest: getLiquidBillingHeader,
  updateRequest: UpdateLiquidBillingInvoice,
  pk: 'billingId',
  name: 'liquidbillingjde',
} as DataSource;


